export enum EquipmentCodeQualifierEnum {
  Aq = 'AQ',
  Te = 'TE',
  Cn = 'CN',
  Zzz = 'ZZZ',
  Unknown = 'Unknown',
}

export const hasEquipmentCodeQualifier = (equipmentCodeQualifier: EquipmentCodeQualifierEnum): boolean =>
  Object.values(EquipmentCodeQualifierEnum).includes(equipmentCodeQualifier);
